import { getLocalStorageToken } from 'store/localStorage'
import { jwtDecode } from 'jwt-decode'
export default function isSSOLoggedIn() {
  const token = getLocalStorageToken()
  if (token) {
    try {
      const decodedJwt = jwtDecode<{ SSO?: boolean }>(token)
      if (decodedJwt.SSO) {
        return true
      }
    } catch (err) {
      return false
    }
    return false
  }
}
